import { ArrowRight, Check } from "lucide-react";
import { Reveal } from "./Reveal";

const PLANS = [
  {
    tag: "PERAWATAN RUTIN",
    name: "Reguler Cleaning",
    desc: "Cocok untuk menjaga rumah tetap nyaman setiap minggu.",
    price: "Rp 60.000",
    points: ["Bersih harian, vakum & pel", "Area utama rumah", "Pilih durasi 3–6 jam"],
    cta: "Pilih Reguler",
    testid: "regular-price-booking",
  },
  {
    tag: "BERSIH MENYELURUH",
    name: "Deep Cleaning",
    desc: "Untuk rumah yang ingin kembali segar sampai ke detail.",
    price: "Rp 75.000",
    points: ["Bersih detail dan menyeluruh", "Fokus area sesuai kebutuhan", "Pilih durasi 3–6 jam"],
    cta: "Pilih Deep Cleaning",
    testid: "deep-price-booking",
    featured: true,
  },
];

export default function Pricing() {
  return (
    <section className="section pricing" id="harga">
      <div className="container">
        <Reveal className="section-head">
          <div>
            <span className="eyebrow">Harga Transparan</span>
            <h2 className="h2">
              Pilih yang paling
              <br />
              <em>pas untuk rumah Anda.</em>
            </h2>
          </div>
          <p>Tanpa biaya tersembunyi. Tinggal pilih kebutuhan, kami yang urus sisanya.</p>
        </Reveal>
        <div className="price-grid">
          {PLANS.map((p, i) => (
            <Reveal key={p.name} delay={i * 0.12} className={`price-card ${p.featured ? "price-feature" : ""}`}>
              <article>
                {p.featured && <span className="popular-tag">PALING POPULER</span>}
                <span className="price-tag">{p.tag}</span>
                <h3>{p.name}</h3>
                <p className="price-desc">{p.desc}</p>
                <strong className="price-value">
                  {p.price} <small>/ jam</small>
                </strong>
                <ul>
                  {p.points.map((pt) => (
                    <li key={pt}>
                      <Check size={15} /> {pt}
                    </li>
                  ))}
                </ul>
                <a href="#pesan" className={p.featured ? "btn-primary" : "btn-outline"} data-testid={p.testid}>
                  {p.cta} <ArrowRight size={15} />
                </a>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
